import Controls from '@stories/Components/Misc/Carousels/Carousel/Controls/Controls';
import Dots from '@stories/Components/Misc/Carousels/Carousel/Dots/Dots';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Pagination.styles';
const Pagination = React.forwardRef((_, ref) => {
    const carousel = useCarouselContext();
    if (carousel.maxIndex === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: ref },
        React.createElement(Dots, { itemCount: carousel.maxIndex < carousel.dotCount ? carousel.maxIndex + 1 : carousel.dotCount, activeIndex: carousel.activeDotIndex, setActiveIndex: (index) => carousel.goToIndex(carousel.scrollByVisibleCount ? index * carousel.visibleItemCount : index) }),
        React.createElement(Controls, null)));
});
Pagination.displayName = 'CarouselPagination';
export default Pagination;
